import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';

@Component({
    selector: 'app-switch-input',
    templateUrl: './switch-input.component.html',
    styleUrls: ['./switch-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SwitchInputComponent,
            multi: true,
        },
    ],
})
export class SwitchInputComponent extends FormControlComponent implements OnInit, OnChanges {
    @Input() public title: string;
    @Input() public label: string;
    @Input() public disabled = false;
    @Input() public readOnly: boolean;

    public control: FormControl;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.control = new FormControl({ value: '', disabled: this.readOnly });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.readOnly && this.control) {
            this.readOnly = changes.readOnly.currentValue;
            if (this.readOnly) {
                this.control.disable();
            } else {
                this.control.enable();
            }
        }
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.control.patchValue(obj);
    }

    public switch(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.control.value;

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }
}
